export default __webpack_public_path__ + "static/media/general-motors.53491b71.svg";